import React from "react";
import "./SearchWidgetStyle.scss";
import SearchIcon from "../../../assets/icons/Search";

const SearchWidget = ({ handleSearchFilterChange }) => {
  return (
    <div className="search-wrap">
      <SearchIcon className="start-icon" />
      <input
        type="text"
        placeholder="Search..."
        className="search-input"
        onChange={handleSearchFilterChange}
      />
    </div>
  );
};

export default SearchWidget;
